import React from 'react'

import { createBrowserRouter } from 'react-router-dom'
import { Consent } from 'pages/Login/Consent'
import { Intro } from 'pages/Login/Intro'
import { BasePage } from 'pages/BasePage'
import { Token } from 'pages/Token'
import { Connections } from 'pages/Connections'
import { RedirectNavigation } from 'pages/Connections/redirectNavigation'

export const routes = [
  {
    path: '/',
    element: <BasePage />,
    children: [
      {
        path: '/',
        element: <RedirectNavigation />,
      },
      {
        path: '/intro',
        element: <Intro />,
      },
      {
        path: '/consent',
        element: <Consent />,
      },
      {
        path: '/token',
        element: <Token />,
      },
      {
        path: '/connections',
        element: <Connections />,
      },
    ],
  },
]

export const router = createBrowserRouter(routes)
